import axios from 'axios';

export function setProductTotals(givenProduct) {
  const product = givenProduct;
  product.totalPrice = product.is_discounted ? product.discounted_price * product.quantity : product.price * product.quantity;
  product.totalPriceWithVat = (product.totalPrice * (100 + product.vat_rate)) / 100;
  const roundedTotalFromSinglePrice = Math.round(product.singlePriceWithVat) * product.quantity;
  const roundedTotalPriceWithVat = Math.floor(product.totalPriceWithVat);
  product.roundedTotalPriceWithVat = roundedTotalPriceWithVat;
  if (roundedTotalPriceWithVat - roundedTotalFromSinglePrice === 1) {
    product.roundedTotalPriceWithVat = roundedTotalFromSinglePrice;
  }
  return product;
}

export function updateProductPrices(givenProduct, discountRule) {
  const product = givenProduct;
  product.is_discounted = true;
  product.discount_rate = discountRule.rate;
  product.discounted_price = product.price - ((product.price * product.discount_rate) / 100);
  product.discounted_price_with_vat = (product.discounted_price * (100 + product.vat_rate)) / 100;
  product.totalPrice = product.is_discounted ? product.discounted_price * product.quantity : product.price * product.quantity;
  product.totalPriceWithVat = (product.totalPrice * (100 + product.vat_rate)) / 100;
  product.singlePriceWithVat = product.is_discounted ? (product.discounted_price * (100 + product.vat_rate)) / 100 : (product.price * (100 + product.vat_rate)) / 100;
  product.vat = product.totalPriceWithVat - product.totalPrice;
  const roundedTotalFromSinglePrice = Math.round(product.singlePriceWithVat) * product.quantity;
  const roundedTotalPriceWithVat = Math.floor(product.totalPriceWithVat);
  product.roundedTotalPriceWithVat = roundedTotalPriceWithVat;
  if (roundedTotalPriceWithVat - roundedTotalFromSinglePrice === 1) {
    product.roundedTotalPriceWithVat = roundedTotalFromSinglePrice;
  }

  return product;
}

export function setNewQuantity(givenProduct, payloadQuantity, quantityToAdd) {
  const product = givenProduct;
  if (payloadQuantity === '+') {
    product.quantity += quantityToAdd;
  } else {
    product.quantity = payloadQuantity;
  }
  return product;
}

export function checkProductQuantity(product) {
  let { quantity } = product;
  if (product.min_quantity && quantity < product.min_quantity) {
    quantity = product.min_quantity;
  }
  if (product.available_quantity && product.quantity > product.available_quantity) {
    quantity = product.available_quantity;
  }
  if (product.max_quantity && quantity > product.max_quantity) {
    quantity = product.max_quantity;
  }
  return quantity;
}

export function getAvailablePayments() {
  return axios.get('/api/available-payments');
}
